import apiClient from './apiClient';

export const dashboardService = {
  async getStats() {
    const response = await apiClient.get('/dashboard/stats');
    return response.data;
  },

  async getRecentActivity(limit = 20) {
    const response = await apiClient.get(`/dashboard/activity?limit=${limit}`);
    return response.data;
  },

  async getAnnouncements() {
    const response = await apiClient.get('/dashboard/announcements');
    return response.data;
  }
};

export default dashboardService;
